// /home/Hakyury/sites/eight-percent.com/frontend/src/component/Footer.jsx
import React, { useEffect } from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Создаем эффект звезд в футере
  useEffect(() => {
    const createFooterStars = () => {
      const footer = document.getElementById('footer-stars');
      if (!footer) return;
      
      footer.innerHTML = '';
      
      for (let i = 0; i < 25; i++) {
        const star = document.createElement('div');
        star.className = 'footer-star';
        star.style.cssText = `
          position: absolute;
          width: ${Math.random() * 1.5 + 0.5}px;
          height: ${Math.random() * 1.5 + 0.5}px;
          background: rgba(255, 255, 255, ${Math.random() * 0.2 + 0.05});
          border-radius: 50%;
          left: ${Math.random() * 100}%;
          top: ${Math.random() * 100}%;
          animation: footer-twinkle ${Math.random() * 3 + 2}s infinite alternate;
          z-index: 0;
        `;
        footer.appendChild(star);
      }
    };
    
    createFooterStars();
    window.addEventListener('resize', createFooterStars);
    return () => window.removeEventListener('resize', createFooterStars);
  }, []);

  return (
    <footer className="relative bg-gradient-to-t from-black via-gray-900/95 to-gray-900 border-t border-white/10 pt-8 pb-8 overflow-hidden">
      {/* Фоновые звезды */}
      <div id="footer-stars" className="absolute inset-0 pointer-events-none"></div>
      
      {/* Туманности */}
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gradient-to-tr from-purple-600/5 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-indigo-600/5 to-transparent rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Копирайт */}
        <div className="text-center text-gray-500 text-sm">
          © {currentYear} Eight Percent
        </div>
      </div>
      
      {/* CSS анимации для звезд */}
      <style jsx>{`
        @keyframes footer-twinkle {
          0%, 100% { opacity: 0.1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;